import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../services/api/API";
import { useLocation } from "react-router-dom";
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import addIcon from "../../../../../Assets/icons/addIconLogistics.svg";
import deleteIcon from "./../../../../../Assets/icons/trash.svg";
import CustomTable from "../../../../customComponents/CustomTable";
import { set } from "date-fns";
import SerialForm from "./SerialForm";

const Serial = ({
  PhysicalStockinId,
  vendorId,
  itemNameData,
  isEdit,
  toggleSerialDrawer=()=>{},
  activeComponent,
  phyItemId,
  setIsEdit,
  formData,
  setFormData,
  serialFormData,
  setserialFormData=()=>{},
  isSerailDrawerOpen,
  serialData,
  businessPartnerIdState
}) => {
  // const [formData, setserialFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const [userTypedd, setUserTypedd] = useState([]);
  const [iseditmode, setisEditMode] = useState(false);
  const [serialList, setSerialList] = useState([]);
  const userType = localStorage.getItem("UserType");
  const [variantId, setVariantId] = useState(0);
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const token = localStorage.getItem("authToken");
  const location = useLocation();
  console.log("seraillocationdata", serialData);
  const [serialID,setSerialId] = useState(null)


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchDepartments(newPage);
  };
  const fetchDepartments = async (page = 0, pageSize = 10) => {
    try {
      const response = await axiosInstance.post(
        "/physicalstocktakeitemserial/list",
        {
          orderBy: "phystockinsr_id desc",
          page,
          pageSize,
          phystkinitem_id: serialData?.phystkin_item_id,
          phystkin_id: PhysicalStockinId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      setTotalRecords(totalRecordsData);

      setSerialList(formattedData);
      
      console.log("response", response);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
  };
  useEffect(() => {
    userTypedropdown();
    if(isSerailDrawerOpen){
      fetchDepartments();
      setValidationErrors({})
    }
   
  }, [isSerailDrawerOpen]);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };
  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    VehicleInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    setIsLoading(true);
    console.log("formData", formData, isEdit);

    try {
      if (iseditmode) {
        const payload = {
          phystkin_id: serialData?.phystkin_id,
          itemtype: serialData?.itemtype,
          phystkinitem_id: serialData?.phystkin_item_id,
          chassis_no: itemNameData === "Vehicle" ? formData?.chassisno : null,
          engine_no: itemNameData === "Vehicle" ? formData?.engineno : null,
          bar_code: null,
          serial_no: formData?.serialno,
          business_partner_id:businessPartnerIdState
        };

        // if (userType === "superadmin") {
        //   payload.business_partner_id = formData.business_partner_id;
        // } else {
        //   payload.business_partner_id = businessPartnerId;
        // }

        const response = await axiosInstance.patch(
          `/physicalstocktakeitemserial/update/${serialID}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Unit added successfully:", response.data);
        fetchDepartments();
        setserialFormData({})
        setisEditMode(false)
      } else {
        const payload = {
          phystkin_id: serialData?.phystkin_id,
          itemtype: serialData?.itemtype,
          phystkinitem_id: serialData?.phystkin_item_id,
          chassis_no: itemNameData === "Vehicle" ? formData?.chassisno : null,
          engine_no: itemNameData === "Vehicle" ? formData?.engineno : null,
          bar_code: null,
          serial_no: formData?.serialno,
          business_partner_id:businessPartnerIdState
        };

        // if (userType === "superadmin") {
        //   payload.business_partner_id = formData.business_partner_id;
        // } else {
        //   payload.business_partner_id = businessPartnerId;
        // }

        const response = await axiosInstance.post(
          "/physicalstocktakeitemserial/create",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Unit added successfully:", response.data);
        fetchDepartments();
        setserialFormData({});
      }

      //navigate('/logistics/manage-stock/physical-stock-taking');
    } catch (error) {
      console.error("Error adding data:", error);

      console.error("Error submitting form:", error);
    } finally {
      setIsLoading(false);
    }
    console.log("clicked");
  };

  console.log("itemnamedata",itemNameData);
 
  
  const VehicleInputs = [

    ...(itemNameData === "Vehicle"?[
      {
        name: "chassisno",
        label: "Chassis No.",
        type: "text",
        placeholder: "Enter Chassis No.",
        // options: logisticComapanies,
        // disabled: fieldsdisabled,
        validation: { required: true },
        required: true,
        gridClass: "col-lg-3",
      },
    ] : [] ),
    ...(itemNameData === "Vehicle"?[
      {
        name: "engineno",
        label: "Engine No.",
        type: "text",
        placeholder: "Enter Engine No.",
        validation: { required: true },
        required: true,
        gridClass: "col-lg-3",
      },
    ] : [] ),
    
      {
        name: "serialno",
        label: "Serial No.",
        type: "text",
        placeholder: "Enter Serial No.",
        validation: { required: true },
        required: true,
        gridClass: "col-lg-3",
      },
   
  ];
  const Serial_TABLE_HEADERS = [
    "Chassis No.",
    "Engine No.",

    "Serial No.",
    "Action",
  ];
  const Serial_KEY_MAPPING = {
    "Chassis No.": "chassis_no",
    "Engine No.": "engine_no",

    "Serial No.": "serial_no",
    Action: [
      { type: "edit", icon: editIcon, label: "Edit" },
      { type: "delete", icon: deleteIcon, label: "Delete" },
    ],
  };


 
  const handleEdit = (rowData) => {
    console.log("rowData>>", rowData);
    setSerialId(rowData?.phystockinsr_id)
    const fetchSparePartExistingDetails = async () => {
      console.log("serialData",serialData);

      try {
        const response = await axiosInstance.get(
          `/physicalstocktakeitemserial/edit/${rowData?.phystockinsr_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          const vehicleData = response.data.data;
          console.log("vehicledata", vehicleData, response);

          const transformedData = {
            business_partner_id: vehicleData?.business_partner_id,
            chassisno: vehicleData.chassis_no,
            engineno: vehicleData.engine_no,
            serialno: vehicleData?.serial_no,
          };

          setFormData(transformedData);

          console.log(
            "Transformed vehicle data set to formData:",
            transformedData
          );
        } else {
          console.error("Failed to fetch vehicle data");
        }
      } catch (error) {
        console.error("Error fetching vehicle data:", error);
      }
    };
    fetchSparePartExistingDetails()
    setisEditMode(true);
  };

  const handleDelete = async (rowData) => {
    console.log("rowData>>>>", rowData);

    try {
      const response = await axiosInstance.delete(
        `/physicalstocktakeitemserial/delete/${serialID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // Create a new array without the deleted item
        const updatedData = serialList.filter(
          (item) => item.phystockinsr_id !== rowData.phystockinsr_id
        );
        setSerialList(updatedData);
        console.log("Item deleted successfully");
      } else {
        console.error("Failed to delete item");
      }
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };


  return (
    <div className="mt-1 mb-3">
      <SerialForm  itemNameData={itemNameData} formData={formData} setFormData={setFormData} serialData={serialData} serialID ={serialID} fetchDepartments={fetchDepartments} iseditmode={iseditmode} setisEditMode={setisEditMode} 
      toggleSerialDrawer={toggleSerialDrawer}
    />
    
      <div className="mt-3">
        <CustomTable
          data={serialList}
          headers={Serial_TABLE_HEADERS}
          keyMapping={Serial_KEY_MAPPING}
          itemsPerPage={10}
          totalRecords={totalRecords} 
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onDelete={handleDelete}
          onEdit={handleEdit}
        />
      </div>
      
    </div>
  );
};

export default Serial;
